import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// R2-004: 17 biz 의 ko/en namespace 일괄 import.
// 키 형식: '<feature>.<section>.<purpose>' (CLAUDE.md §9 규약).
import loginKo from './features/login/i18n/ko.json';
import loginEn from './features/login/i18n/en.json';
import logoutKo from './features/logout/i18n/ko.json';
import logoutEn from './features/logout/i18n/en.json';
import passwordResetKo from './features/password-reset/i18n/ko.json';
import passwordResetEn from './features/password-reset/i18n/en.json';
import tokenInspectorKo from './features/token-inspector/i18n/ko.json';
import tokenInspectorEn from './features/token-inspector/i18n/en.json';
import userManagementKo from './features/user-management/i18n/ko.json';
import userManagementEn from './features/user-management/i18n/en.json';
import roleManagementKo from './features/role-management/i18n/ko.json';
import roleManagementEn from './features/role-management/i18n/en.json';
import permissionDemoKo from './features/permission-demo/i18n/ko.json';
import permissionDemoEn from './features/permission-demo/i18n/en.json';
import myProfileKo from './features/my-profile/i18n/ko.json';
import myProfileEn from './features/my-profile/i18n/en.json';
import commonCodeKo from './features/common-code/i18n/ko.json';
import commonCodeEn from './features/common-code/i18n/en.json';
import auditLogKo from './features/audit-log/i18n/ko.json';
import auditLogEn from './features/audit-log/i18n/en.json';
import menuManagementKo from './features/menu-management/i18n/ko.json';
import menuManagementEn from './features/menu-management/i18n/en.json';
import commonShowcaseKo from './features/common-showcase/i18n/ko.json';
import commonShowcaseEn from './features/common-showcase/i18n/en.json';
import errorDemoKo from './features/error-demo/i18n/ko.json';
import errorDemoEn from './features/error-demo/i18n/en.json';
import attachmentDemoKo from './features/attachment-demo/i18n/ko.json';
import attachmentDemoEn from './features/attachment-demo/i18n/en.json';
import eventMonitorKo from './features/event-monitor/i18n/ko.json';
import eventMonitorEn from './features/event-monitor/i18n/en.json';
import systemSettingsKo from './features/system-settings/i18n/ko.json';
import systemSettingsEn from './features/system-settings/i18n/en.json';
import terminologyManagementKo from './features/terminology-management/i18n/ko.json';
import terminologyManagementEn from './features/terminology-management/i18n/en.json';
import devStandardsViewerKo from './features/dev-standards-viewer/i18n/ko.json';
import devStandardsViewerEn from './features/dev-standards-viewer/i18n/en.json';
import approvalCenterKo from './features/approval-center/i18n/ko.json';
import approvalCenterEn from './features/approval-center/i18n/en.json';
import notificationCenterKo from './features/notification-center/i18n/ko.json';
import notificationCenterEn from './features/notification-center/i18n/en.json';
import reportBuilderKo from './features/report-builder/i18n/ko.json';
import reportBuilderEn from './features/report-builder/i18n/en.json';
import sagaMonitorKo from './features/saga-monitor/i18n/ko.json';
import sagaMonitorEn from './features/saga-monitor/i18n/en.json';
import tenantSwitcherKo from './features/tenant-switcher/i18n/ko.json';
import tenantSwitcherEn from './features/tenant-switcher/i18n/en.json';
import integrationHubKo from './features/integration-hub/i18n/ko.json';
import integrationHubEn from './features/integration-hub/i18n/en.json';
import retentionAdminKo from './features/retention-admin/i18n/ko.json';
import retentionAdminEn from './features/retention-admin/i18n/en.json';
import configCenterKo from './features/config-center/i18n/ko.json';
import configCenterEn from './features/config-center/i18n/en.json';
import schedulerMonitorKo from './features/scheduler-monitor/i18n/ko.json';
import schedulerMonitorEn from './features/scheduler-monitor/i18n/en.json';
import changeHistoryViewerKo from './features/change-history-viewer/i18n/ko.json';
import changeHistoryViewerEn from './features/change-history-viewer/i18n/en.json';
import cacheAdminKo from './features/cache-admin/i18n/ko.json';
import cacheAdminEn from './features/cache-admin/i18n/en.json';
import realtimeConsoleKo from './features/realtime-console/i18n/ko.json';
import realtimeConsoleEn from './features/realtime-console/i18n/en.json';
import platformLabKo from './features/platform-lab/i18n/ko.json';
import platformLabEn from './features/platform-lab/i18n/en.json';
import gettingStartedGuideKo from './features/getting-started-guide/i18n/ko.json';
import gettingStartedGuideEn from './features/getting-started-guide/i18n/en.json';
import projectScaffoldKo from './features/project-scaffold/i18n/ko.json';
import projectScaffoldEn from './features/project-scaffold/i18n/en.json';
import indexKo from './features/_index/i18n/ko.json';
import indexEn from './features/_index/i18n/en.json';
import sharedKo from './features/_shared/i18n/ko.json';
import sharedEn from './features/_shared/i18n/en.json';
import gatewaySharedKo from './features/gateway-admin/_shared/i18n/ko.json';
import gatewaySharedEn from './features/gateway-admin/_shared/i18n/en.json';
import gatewayRoutesKo from './features/gateway-admin/routes/i18n/ko.json';
import gatewayRoutesEn from './features/gateway-admin/routes/i18n/en.json';
import gatewayApisKo from './features/gateway-admin/apis/i18n/ko.json';
import gatewayApisEn from './features/gateway-admin/apis/i18n/en.json';
import gatewayServicesKo from './features/gateway-admin/services/i18n/ko.json';
import gatewayServicesEn from './features/gateway-admin/services/i18n/en.json';
import gatewayPluginsKo from './features/gateway-admin/plugins/i18n/ko.json';
import gatewayPluginsEn from './features/gateway-admin/plugins/i18n/en.json';
import gatewayTargetsKo from './features/gateway-admin/targets/i18n/ko.json';
import gatewayTargetsEn from './features/gateway-admin/targets/i18n/en.json';
import gatewayRoutingOverviewKo from './features/gateway-admin/routing-overview/i18n/ko.json';
import gatewayRoutingOverviewEn from './features/gateway-admin/routing-overview/i18n/en.json';
import gatewayConsumersKo from './features/gateway-admin/consumers/i18n/ko.json';
import gatewayConsumersEn from './features/gateway-admin/consumers/i18n/en.json';
import gatewayUpstreamsKo from './features/gateway-admin/upstreams/i18n/ko.json';
import gatewayUpstreamsEn from './features/gateway-admin/upstreams/i18n/en.json';
import gatewayCertificatesKo from './features/gateway-admin/certificates/i18n/ko.json';
import gatewayCertificatesEn from './features/gateway-admin/certificates/i18n/en.json';
import gatewayConsumerGroupsKo from './features/gateway-admin/consumer-groups/i18n/ko.json';
import gatewayConsumerGroupsEn from './features/gateway-admin/consumer-groups/i18n/en.json';

const STORAGE_KEY = 'eraf.lang';
const initialLang = (localStorage.getItem(STORAGE_KEY) as 'ko' | 'en') ?? 'ko';

// gateway-admin 의 모든 sub-feature i18n 은 동일한 top-level 키 'gateway' 를 공유한다
// (gatewayApisKo = {gateway: {apis: ...}}, gatewayServicesKo = {gateway: {services: ...}}).
// 단순 spread (...) 는 'gateway' 키를 덮어써 마지막 bundle 만 살아남으므로 deep merge 가 필요하다.
// (R7-017 prod 회귀 root cause — enhance-biz #240)
type Bundle = Record<string, unknown>;
function deepMerge(target: Bundle, source: Bundle): Bundle {
  const out: Bundle = { ...target };
  for (const k of Object.keys(source)) {
    const sv = source[k];
    const tv = out[k];
    if (
      sv && typeof sv === 'object' && !Array.isArray(sv) &&
      tv && typeof tv === 'object' && !Array.isArray(tv)
    ) {
      out[k] = deepMerge(tv as Bundle, sv as Bundle);
    } else {
      out[k] = sv;
    }
  }
  return out;
}
function mergeAll(...bundles: Bundle[]): Bundle {
  return bundles.reduce<Bundle>((acc, b) => deepMerge(acc, b), {});
}

// 모든 biz 의 키를 단일 'common' namespace 로 합산 — useTranslation() 호출 단순화.
// 일반 biz 키는 flat ('feature.xxx.yyy' 단일 키) 라 spread 가능. gateway-admin 만 nested.
const ko = mergeAll(
  loginKo, logoutKo, passwordResetKo, tokenInspectorKo,
  userManagementKo, roleManagementKo, permissionDemoKo, myProfileKo,
  commonCodeKo, auditLogKo, menuManagementKo, commonShowcaseKo,
  errorDemoKo, attachmentDemoKo, eventMonitorKo, systemSettingsKo,
  terminologyManagementKo,
  devStandardsViewerKo,
  indexKo,
  sharedKo,
  gatewaySharedKo, gatewayRoutesKo, gatewayApisKo,
  gatewayServicesKo, gatewayPluginsKo, gatewayTargetsKo,
  gatewayRoutingOverviewKo,
  gatewayConsumersKo, gatewayUpstreamsKo, gatewayCertificatesKo, gatewayConsumerGroupsKo,
  approvalCenterKo, notificationCenterKo, reportBuilderKo, sagaMonitorKo, tenantSwitcherKo,
  integrationHubKo, retentionAdminKo,
  configCenterKo, schedulerMonitorKo, changeHistoryViewerKo, cacheAdminKo, realtimeConsoleKo, platformLabKo,
  gettingStartedGuideKo,
  projectScaffoldKo,
  {
    // AppShell 공통 라벨 (페이지마다 반복되는 단어)
    'common.action.search': '검색',
    'common.action.reset': '초기화',
    'common.action.save': '저장',
    'common.action.cancel': '취소',
    'common.action.delete': '삭제',
    'common.action.refresh': '새로고침',
    'common.nav.home': '홈',
    'common.nav.dashboard': '대시보드',
  },
);

const en = mergeAll(
  loginEn, logoutEn, passwordResetEn, tokenInspectorEn,
  userManagementEn, roleManagementEn, permissionDemoEn, myProfileEn,
  commonCodeEn, auditLogEn, menuManagementEn, commonShowcaseEn,
  errorDemoEn, attachmentDemoEn, eventMonitorEn, systemSettingsEn,
  terminologyManagementEn,
  devStandardsViewerEn,
  indexEn,
  sharedEn,
  gatewaySharedEn, gatewayRoutesEn, gatewayApisEn,
  gatewayServicesEn, gatewayPluginsEn, gatewayTargetsEn,
  gatewayRoutingOverviewEn,
  gatewayConsumersEn, gatewayUpstreamsEn, gatewayCertificatesEn, gatewayConsumerGroupsEn,
  approvalCenterEn, notificationCenterEn, reportBuilderEn, sagaMonitorEn, tenantSwitcherEn,
  integrationHubEn, retentionAdminEn,
  configCenterEn, schedulerMonitorEn, changeHistoryViewerEn, cacheAdminEn, realtimeConsoleEn, platformLabEn,
  gettingStartedGuideEn,
  projectScaffoldEn,
  {
    'common.action.search': 'Search',
    'common.action.reset': 'Reset',
    'common.action.save': 'Save',
    'common.action.cancel': 'Cancel',
    'common.action.delete': 'Delete',
    'common.action.refresh': 'Refresh',
    'common.nav.home': 'Home',
    'common.nav.dashboard': 'Dashboard',
  },
);

void i18n
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'ko',
    supportedLngs: ['ko', 'en'],
    interpolation: { escapeValue: false },
    resources: {
      ko: { common: ko },
      en: { common: en },
    },
    defaultNS: 'common',
  });

// R7-004: html[lang] 초기 동기화 — i18next 의 lng 와 document.documentElement.lang 일치
if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLang;
}

// R7-004: 언어 변경 시 html[lang] 자동 갱신
i18n.on('languageChanged', (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
  // R7-029: localStorage 에 저장 (i18next-browser-languagedetector 없이 직접 관리)
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
  }
});

// ui-kit AppShell 에서 동적으로 changeLanguage 호출하기 위해 window 에 노출
// (ui-kit 은 i18next 직접 의존 X — 패키지 분리 위해)
if (typeof window !== 'undefined') {
  (window as Window & { __eraf_i18n?: typeof i18n }).__eraf_i18n = i18n;
}

export default i18n;
